// Instructor carousel: arrow paging, autoplay, and a one-time entrance reveal.
//
// Progressive enhancement only. Without this file the track is still a native
// horizontal scroller with snap points and every card is reachable, so no
// content depends on the script.
//
// QA note: headless and embedded-preview browsers report
// document.visibilityState === "hidden" permanently, and a hidden document
// fires no IntersectionObserver callbacks. The reveal is therefore applied
// immediately when the observer is unavailable or the document is hidden,
// which is also what makes the cards visible in a screenshot.
(function () {
  var roots = document.querySelectorAll('[data-ds-carousel]');
  if (!roots.length) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var track = root.querySelector('[data-ds-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-ds-carousel-prev]');
    var next = root.querySelector('[data-ds-carousel-next]');

    function step() {
      var card = track.querySelector('.ds-icar__item');
      return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    }
    function atEnd() { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }
    function page(dir) { track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }

    function sync() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = atEnd();
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();

    // --- Autoplay -------------------------------------------------------
    // Advances one card, wrapping to the start at the end. Pauses on hover,
    // on keyboard focus, while the tab is hidden, and whenever the visitor
    // scrolls the track themselves — autoplay that fights the user is worse
    // than none. Skipped entirely under prefers-reduced-motion.
    var ms = parseInt(root.getAttribute('data-ds-autoplay'), 10);
    if (!ms || reduced) return;
    var timer = null, paused = false;

    function tick() {
      if (paused || document.visibilityState === 'hidden') return;
      if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else page(1);
    }
    function start() { if (!timer) timer = window.setInterval(tick, ms); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stop(); else start();
    });
    // A real scroll gesture stops autoplay for good; the arrows still work.
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, function () { stop(); }, { passive: true, once: true });
    });
    start();
  });

  // --- Entrance reveal ---------------------------------------------------
  Array.prototype.forEach.call(roots, function (root) {
    root.setAttribute('data-reveal', '');
    var show = function () { root.classList.add('is-in'); };
    if (!('IntersectionObserver' in window) || document.visibilityState === 'hidden') { show(); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { show(); io.disconnect(); }
    }, { threshold: 0.12 });
    io.observe(root);
    window.setTimeout(show, 1200);
  });
})();
